module.exports = __webpack_public_path__ + "static/media/upload.43fc8862.svg";